<template>
  <v-dialog
    v-model="show"
    max-width="400"
    overlay-color="darktext"
    overlay-opacity="0.6"
  >
    <v-card>
      <v-card-title>
        {{ $t('confirmationDialogTitleEmbedVideo') }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn()"
          @submit.prevent
        >
          <v-text-field
            v-model="url"
            data-testid="dialog-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2 pt-4"
            :placeholder="$t('confirmationDialogInputPlaceholderEmbedVideo')"
            :hint="$t('confirmationDialogInputHintEmbedVideo')"
            persistent-hint
            :rules="urlRules"
            :error-messages="errors"
          />
          <v-card-actions>
            <v-spacer />
            <v-btn
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              @click="show=false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              ref="submit"
              data-testid="submit-button"
              type="submit"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              :loading="loading"
              @click="submitDialogBtn"
            >
              {{ $t('embed') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired } from '../rules/formRules.js';
import i18n from '../plugins/i18n'
import { oembed } from "@loomhq/loom-embed";

export default {
  props: {
    visible: Boolean
  },
  data(){
        return{
          alertMsg: '',
          url: '',
          valid: true,
          urlRules: ruleRequired('labelVideoURL'),
          errors: [],
          loading: false
         }
    },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
          this.$refs.form.reset()
        }
      }
    }
  },
  watch: {
    url(){
      this.errors = []
    }
  },
  methods: {
    async submitDialogBtn() {
      this.valid = this.$refs.form.validate()
      if(this.valid){
        if(this.url.includes('youtu'))
        {
            var youtubeRegex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
            if(this.url.match(youtubeRegex)){
              this.loading = true
              this.$emit('proceedSubmit', 'https://www.youtube.com/embed/' + this.url.match(youtubeRegex)[1])
            }else {
              this.errors = [i18n.t('videoURLErrorValid')]
            }
        } else if (this.url.includes('vimeo')){
          const endpoint = 'https://vimeo.com/api/oembed.json';
          fetch(`${endpoint}?url=${encodeURIComponent(this.url)}`, { 
            method: 'get',
            cache: 'no-cache', 
            mode: 'cors',

          })
          .then((response) => { return response.json();})
          .then((res) =>  {
              if(this.url.split('/').pop() != '' && this.url.split('/').pop() != res.video_id){
                this.$emit('proceedSubmit', 'https://player.vimeo.com/video/'+res.video_id+'?h='+this.url.split('/').pop())
              }else {
                this.$emit('proceedSubmit', 'https://player.vimeo.com/video/'+res.video_id)
              }
              this.loading = true
          })
          .catch(() => this.errors = [i18n.t('videoURLErrorValid')])              
        } else if (this.url.includes('loom')){
          //get url without query params because oembed will not work
          this.url = this.url.split('?')[0]
          try {
            await oembed(this.url)
            this.url = this.url.replace('share', 'embed');
            this.$emit('proceedSubmit', this.url)
            this.loading = true
          } catch (e) {
            this.errors = [i18n.t('videoURLErrorValid')]
          }    
        } else {
          this.errors = [i18n.t('videoURLErrorValid')]
        }
      }
    }
  }
}
</script>